export default "__VITE_ASSET__DJPvgK8s__"